import styled, { keyframes } from 'styled-components/macro';

const show = keyframes`
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
`;

export const ScPreloader = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${({ theme }) => theme.secondaryColor4};
  & > svg {
    width: 90px;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    path {
      fill: ${({ theme }) => theme.mainColor};
    }
  }
  .logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    animation: ${show} 1s linear forwards;
    & > svg {
      width: 120px;
      height: auto;
    }
  }
`;
